/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const archiveMission = /* GraphQL */ `mutation ArchiveMission($input: ArchiveMissionInput!) {
  archiveMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.ArchiveMissionMutationVariables,
  APITypes.ArchiveMissionMutation
>;
export const archiveMissionV2 = /* GraphQL */ `mutation ArchiveMissionV2($input: ArchiveMissionInput!) {
  archiveMissionV2(input: $input) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on MissionV2 {
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        lastRepeatedAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        repeatCount
        type
      }
      fleetId
      id
      name
      plannedArrivalTime
      progressDetails {
        error {
          raisedAt
          type
        }
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        positions {
          altitude
          heading
          latitude
          longitude
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
      }
      state {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      timestamp
      version
      vin
    }
  }
}
` as GeneratedMutation<
  APITypes.ArchiveMissionV2MutationVariables,
  APITypes.ArchiveMissionV2Mutation
>;
export const assignMission = /* GraphQL */ `mutation AssignMission($input: AssignMissionInput!) {
  assignMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.AssignMissionMutationVariables,
  APITypes.AssignMissionMutation
>;
export const cancelMission = /* GraphQL */ `mutation CancelMission($input: CancelMissionInput!) {
  cancelMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.CancelMissionMutationVariables,
  APITypes.CancelMissionMutation
>;
export const cancelMissionV2 = /* GraphQL */ `mutation CancelMissionV2($input: CancelMissionInput!) {
  cancelMissionV2(input: $input) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on MissionV2 {
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        lastRepeatedAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        repeatCount
        type
      }
      fleetId
      id
      name
      plannedArrivalTime
      progressDetails {
        error {
          raisedAt
          type
        }
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        positions {
          altitude
          heading
          latitude
          longitude
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
      }
      state {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      timestamp
      version
      vin
    }
  }
}
` as GeneratedMutation<
  APITypes.CancelMissionV2MutationVariables,
  APITypes.CancelMissionV2Mutation
>;
export const continueStream = /* GraphQL */ `mutation ContinueStream($input: ContinueStreamInput!) {
  continueStream(input: $input) {
    cameraID
    vin
  }
}
` as GeneratedMutation<
  APITypes.ContinueStreamMutationVariables,
  APITypes.ContinueStreamMutation
>;
export const createFleet = /* GraphQL */ `mutation CreateFleet($input: CreateFleetInput!) {
  createFleet(input: $input) {
    createdAt
    id
    name
    numberOfVehicles
    teams {
      id
      name
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.CreateFleetMutationVariables,
  APITypes.CreateFleetMutation
>;
export const createHub = /* GraphQL */ `mutation CreateHub($input: CreateHubInput!) {
  createHub(input: $input) {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.CreateHubMutationVariables,
  APITypes.CreateHubMutation
>;
export const createMissionV2 = /* GraphQL */ `mutation CreateMissionV2($input: CreateMissionInputV2!) {
  createMissionV2(input: $input) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on MissionV2 {
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        lastRepeatedAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        repeatCount
        type
      }
      fleetId
      id
      name
      plannedArrivalTime
      progressDetails {
        error {
          raisedAt
          type
        }
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        positions {
          altitude
          heading
          latitude
          longitude
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
      }
      state {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      timestamp
      version
      vin
    }
  }
}
` as GeneratedMutation<
  APITypes.CreateMissionV2MutationVariables,
  APITypes.CreateMissionV2Mutation
>;
export const createTeam = /* GraphQL */ `mutation CreateTeam($input: CreateTeamInput!) {
  createTeam(input: $input) {
    createdAt
    fleets
    id
    name
    updatedAt
    users
  }
}
` as GeneratedMutation<
  APITypes.CreateTeamMutationVariables,
  APITypes.CreateTeamMutation
>;
export const createUser = /* GraphQL */ `mutation CreateUser($input: CreateUserInput!) {
  createUser(input: $input) {
    city
    country
    createdAt
    email
    firstName
    id
    lastName
    phone
    roles {
      claims {
        createdAt
        pattern
        updatedAt
      }
      createdAt
      id
      name
      updatedAt
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.CreateUserMutationVariables,
  APITypes.CreateUserMutation
>;
export const deleteUserById = /* GraphQL */ `mutation DeleteUserById($input: ID!) {
  deleteUserById(input: $input) {
    ... on DeleteUserSuccessful {
      statusCode
    }
    ... on NotFoundError {
      errorCode
      statusCode
    }
    ... on SelfDeleteError {
      errorCode
      statusCode
    }
    ... on SystemError {
      errorCode
      statusCode
    }
    ... on ValidationError {
      errorCode
      statusCode
    }
  }
}
` as GeneratedMutation<
  APITypes.DeleteUserByIdMutationVariables,
  APITypes.DeleteUserByIdMutation
>;
export const deleteVehicleDeviationsByVin = /* GraphQL */ `mutation DeleteVehicleDeviationsByVin($input: DeleteVehicleDeviationsInput!) {
  deleteVehicleDeviationsByVin(input: $input) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleDeviationsByVinMutationVariables,
  APITypes.DeleteVehicleDeviationsByVinMutation
>;
export const deleteVehicleDeviationsByVinV2 = /* GraphQL */ `mutation DeleteVehicleDeviationsByVinV2($input: DeleteVehicleDeviationsInput!) {
  deleteVehicleDeviationsByVinV2(input: $input) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on VehicleV2 {
      activeMissionId {
        error {
          raisedAt
          type
        }
        ttl
        value {
          data
          updatedAt
        }
      }
      adsState {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      connectivityStatus {
        error {
          raisedAt
          type
        }
        ttl
        value {
          expectDisconnection
          latency
          state
          updatedAt
        }
      }
      deviations {
        error {
          raisedAt
          type
        }
        ttl
        value {
          deviation {
            category
            description
            id
            isBlocking
            origin
            relatedDeviations
            resolvedAt
            sentAt
            severity
            state
          }
          updatedAt
        }
      }
      driverMode {
        error {
          raisedAt
          type
        }
        ttl
        value {
          mode
          updatedAt
        }
      }
      drivingState {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      fleetId
      latestVehicleUpdate
      licensePlate
      mrmState {
        error {
          raisedAt
          type
        }
        ttl
        value {
          data {
            causes
            executionPhase
            mrmType
            startedAt
            triggerBy
            value
          }
          updatedAt
        }
      }
      name
      owners {
        email
        fullName
        id
        phoneNumber
        position
      }
      position {
        error {
          raisedAt
          type
        }
        ttl
        value {
          position {
            altitude
            heading
            latitude
            longitude
          }
          updatedAt
        }
      }
      speedMs {
        error {
          raisedAt
          type
        }
        ttl
        value {
          speedMs
          updatedAt
        }
      }
      timestamp
      vin
    }
  }
}
` as GeneratedMutation<
  APITypes.DeleteVehicleDeviationsByVinV2MutationVariables,
  APITypes.DeleteVehicleDeviationsByVinV2Mutation
>;
export const resetMission = /* GraphQL */ `mutation ResetMission($input: ResetMissionInput!) {
  resetMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.ResetMissionMutationVariables,
  APITypes.ResetMissionMutation
>;
export const resetMissionV2 = /* GraphQL */ `mutation ResetMissionV2($input: ResetMissionInput!) {
  resetMissionV2(input: $input) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on MissionV2 {
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        lastRepeatedAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        repeatCount
        type
      }
      fleetId
      id
      name
      plannedArrivalTime
      progressDetails {
        error {
          raisedAt
          type
        }
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        positions {
          altitude
          heading
          latitude
          longitude
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
      }
      state {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      timestamp
      version
      vin
    }
  }
}
` as GeneratedMutation<
  APITypes.ResetMissionV2MutationVariables,
  APITypes.ResetMissionV2Mutation
>;
export const resetPasswordById = /* GraphQL */ `mutation ResetPasswordById($input: ID!) {
  resetPasswordById(input: $input) {
    ... on NotFoundError {
      errorCode
      statusCode
    }
    ... on ResetPasswordSuccessful {
      statusCode
    }
    ... on SystemError {
      errorCode
      statusCode
    }
    ... on UserNotActiveError {
      errorCode
      statusCode
    }
    ... on ValidationError {
      errorCode
      statusCode
    }
  }
}
` as GeneratedMutation<
  APITypes.ResetPasswordByIdMutationVariables,
  APITypes.ResetPasswordByIdMutation
>;
export const startMission = /* GraphQL */ `mutation StartMission($input: StartMissionInput!) {
  startMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.StartMissionMutationVariables,
  APITypes.StartMissionMutation
>;
export const startMissionV2 = /* GraphQL */ `mutation StartMissionV2($input: StartMissionInput!) {
  startMissionV2(input: $input) {
    ... on ErrorResponse {
      errorCode
      statusCode
    }
    ... on MissionV2 {
      actualArrivalTime
      actualStartTime
      description
      events {
        createdAt
        lastRepeatedAt
        position {
          altitude
          heading
          latitude
          longitude
        }
        repeatCount
        type
      }
      fleetId
      id
      name
      plannedArrivalTime
      progressDetails {
        error {
          raisedAt
          type
        }
        ttl
        value {
          eta
          remainingDistanceInMeters
          traveledDistanceInMeters
          updatedAt
        }
      }
      route {
        createdAt
        durationInSeconds
        externalRouteId
        landingHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        launchHub {
          active
          address
          createdAt
          id
          name
          position {
            latitude
            longitude
          }
          updatedAt
        }
        positions {
          altitude
          heading
          latitude
          longitude
        }
        predefinedRouteId
        totalDistanceInMeters
        updatedAt
      }
      state {
        error {
          raisedAt
          type
        }
        ttl
        value {
          state
          updatedAt
        }
      }
      timestamp
      version
      vin
    }
  }
}
` as GeneratedMutation<
  APITypes.StartMissionV2MutationVariables,
  APITypes.StartMissionV2Mutation
>;
export const triggerVehicleCommand = /* GraphQL */ `mutation TriggerVehicleCommand($input: VehicleCommandInput!) {
  triggerVehicleCommand(input: $input) {
    command
    errorMessage
    invocationId
    isSuccess
    receivedByVehicleAt
    sentToVehicleAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.TriggerVehicleCommandMutationVariables,
  APITypes.TriggerVehicleCommandMutation
>;
export const updateFleetById = /* GraphQL */ `mutation UpdateFleetById($input: UpdatedFleetInput!) {
  updateFleetById(input: $input) {
    createdAt
    id
    name
    numberOfVehicles
    teams {
      id
      name
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.UpdateFleetByIdMutationVariables,
  APITypes.UpdateFleetByIdMutation
>;
export const updateHub = /* GraphQL */ `mutation UpdateHub($input: UpdateHubInput!) {
  updateHub(input: $input) {
    active
    address
    createdAt
    id
    name
    position {
      latitude
      longitude
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.UpdateHubMutationVariables,
  APITypes.UpdateHubMutation
>;
export const updateTeam = /* GraphQL */ `mutation UpdateTeam($input: UpdateTeamInput!) {
  updateTeam(input: $input) {
    createdAt
    fleets
    id
    name
    updatedAt
    users
  }
}
` as GeneratedMutation<
  APITypes.UpdateTeamMutationVariables,
  APITypes.UpdateTeamMutation
>;
export const updateUserById = /* GraphQL */ `mutation UpdateUserById($input: UpdatedUserInput!) {
  updateUserById(input: $input) {
    city
    country
    createdAt
    email
    firstName
    id
    lastName
    phone
    roles {
      claims {
        createdAt
        pattern
        updatedAt
      }
      createdAt
      id
      name
      updatedAt
      useWildcardClaims
    }
    status
    teams {
      id
      name
    }
    updatedAt
  }
}
` as GeneratedMutation<
  APITypes.UpdateUserByIdMutationVariables,
  APITypes.UpdateUserByIdMutation
>;
export const updatedMission = /* GraphQL */ `mutation UpdatedMission($input: UpdatedMissionInput!) {
  updatedMission(input: $input) {
    actualArrivalTime
    actualStartTime
    createdAt
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      eta
      remainingDistanceInMeters
      traveledDistanceInMeters
      updatedAt
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
      waypoints {
        altitude
        heading
        latitude
        longitude
      }
    }
    state {
      updatedAt
      value
    }
    updatedAt
    vin
  }
}
` as GeneratedMutation<
  APITypes.UpdatedMissionMutationVariables,
  APITypes.UpdatedMissionMutation
>;
export const updatedMissionV2 = /* GraphQL */ `mutation UpdatedMissionV2($input: UpdatedMissionInputV2!) {
  updatedMissionV2(input: $input) {
    actualArrivalTime
    actualStartTime
    description
    events {
      createdAt
      lastRepeatedAt
      position {
        altitude
        heading
        latitude
        longitude
      }
      repeatCount
      type
    }
    fleetId
    id
    name
    plannedArrivalTime
    progressDetails {
      error {
        raisedAt
        type
      }
      ttl
      value {
        eta
        remainingDistanceInMeters
        traveledDistanceInMeters
        updatedAt
      }
    }
    route {
      createdAt
      durationInSeconds
      externalRouteId
      landingHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      launchHub {
        active
        address
        createdAt
        id
        name
        position {
          latitude
          longitude
        }
        updatedAt
      }
      positions {
        altitude
        heading
        latitude
        longitude
      }
      predefinedRouteId
      totalDistanceInMeters
      updatedAt
    }
    state {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    timestamp
    version
    vin
  }
}
` as GeneratedMutation<
  APITypes.UpdatedMissionV2MutationVariables,
  APITypes.UpdatedMissionV2Mutation
>;
export const updatedMissionV3 = /* GraphQL */ `mutation UpdatedMissionV3($input: UpdatedMissionInputV3!) {
  updatedMissionV3(input: $input) {
    fleetId
    payload {
      ... on MissionUnassigned {
        fleetId
        timestamp
        version
        vin
      }
      ... on MissionV2 {
        actualArrivalTime
        actualStartTime
        description
        events {
          createdAt
          lastRepeatedAt
          position {
            altitude
            heading
            latitude
            longitude
          }
          repeatCount
          type
        }
        fleetId
        id
        name
        plannedArrivalTime
        progressDetails {
          error {
            raisedAt
            type
          }
          ttl
          value {
            eta
            remainingDistanceInMeters
            traveledDistanceInMeters
            updatedAt
          }
        }
        route {
          createdAt
          durationInSeconds
          externalRouteId
          landingHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          launchHub {
            active
            address
            createdAt
            id
            name
            position {
              latitude
              longitude
            }
            updatedAt
          }
          positions {
            altitude
            heading
            latitude
            longitude
          }
          predefinedRouteId
          totalDistanceInMeters
          updatedAt
        }
        state {
          error {
            raisedAt
            type
          }
          ttl
          value {
            state
            updatedAt
          }
        }
        timestamp
        version
        vin
      }
    }
    vin
  }
}
` as GeneratedMutation<
  APITypes.UpdatedMissionV3MutationVariables,
  APITypes.UpdatedMissionV3Mutation
>;
export const updatedVehicle = /* GraphQL */ `mutation UpdatedVehicle($input: UpdatedVehicleInput) {
  updatedVehicle(input: $input) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVehicleMutationVariables,
  APITypes.UpdatedVehicleMutation
>;
export const updatedVehicleByVin = /* GraphQL */ `mutation UpdatedVehicleByVin($input: UpdatedVehicleByVinInput) {
  updatedVehicleByVin(input: $input) {
    activeMissionId
    adsState
    cameras {
      id
      name
    }
    connectivityStatus {
      description
      expectedDisconnect
      latency
      reason
      state
    }
    createdAt
    customerId
    deviations {
      category
      description
      id
      isBlocking
      origin
      relatedDeviations
      resolvedAt
      sentAt
      severity
      state
    }
    driverMode
    drivingState
    externalId
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      causes {
        deviationId
      }
      error
      mrmExecutionPhase
      mrmType
      startedAt
      triggerBy
      updatedAt
      value
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      altitude
      heading
      latitude
      longitude
    }
    speedInKmh
    speedInMs
    updatedAt
    vin
    weightInKg
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVehicleByVinMutationVariables,
  APITypes.UpdatedVehicleByVinMutation
>;
export const updatedVehicleV2 = /* GraphQL */ `mutation UpdatedVehicleV2($input: UpdatedVehicleInputV2!) {
  updatedVehicleV2(input: $input) {
    activeMissionId {
      error {
        raisedAt
        type
      }
      ttl
      value {
        data
        updatedAt
      }
    }
    adsState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    connectivityStatus {
      error {
        raisedAt
        type
      }
      ttl
      value {
        expectDisconnection
        latency
        state
        updatedAt
      }
    }
    deviations {
      error {
        raisedAt
        type
      }
      ttl
      value {
        deviation {
          category
          description
          id
          isBlocking
          origin
          relatedDeviations
          resolvedAt
          sentAt
          severity
          state
        }
        updatedAt
      }
    }
    driverMode {
      error {
        raisedAt
        type
      }
      ttl
      value {
        mode
        updatedAt
      }
    }
    drivingState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        state
        updatedAt
      }
    }
    fleetId
    latestVehicleUpdate
    licensePlate
    mrmState {
      error {
        raisedAt
        type
      }
      ttl
      value {
        data {
          causes
          executionPhase
          mrmType
          startedAt
          triggerBy
          value
        }
        updatedAt
      }
    }
    name
    owners {
      email
      fullName
      id
      phoneNumber
      position
    }
    position {
      error {
        raisedAt
        type
      }
      ttl
      value {
        position {
          altitude
          heading
          latitude
          longitude
        }
        updatedAt
      }
    }
    speedMs {
      error {
        raisedAt
        type
      }
      ttl
      value {
        speedMs
        updatedAt
      }
    }
    timestamp
    vin
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVehicleV2MutationVariables,
  APITypes.UpdatedVehicleV2Mutation
>;
export const updatedVideoStreamingError = /* GraphQL */ `mutation UpdatedVideoStreamingError($input: UpdatedVideoStreamingErrorInput!) {
  updatedVideoStreamingError(input: $input) {
    cameraID
    errorCode
    errorMessage
    vin
  }
}
` as GeneratedMutation<
  APITypes.UpdatedVideoStreamingErrorMutationVariables,
  APITypes.UpdatedVideoStreamingErrorMutation
>;
